import classNames from 'classnames';
import type { CSSProperties } from 'react';
import * as styles from './ListItem.css';
import type { ListItemElementProps } from './ListItem.types';

export function ListItemElement(props: ListItemElementProps) {
  const { element, children, attributes, className, ...rest } = props;
  const { mobile_hide, desktop_hide, customAttributes, textStyleAttrs } = element.attrs || {};
  const {
    color: markerColor,
    fontWeight: markerFontWeight,
    fontFamily: markerFontFamily,
    fontSize: markerFontSize,
  } = textStyleAttrs || {};

  return (
    <li
      {...customAttributes}
      {...rest}
      className={classNames(
        className,
        {
          'mobile:hidden': mobile_hide,
          'desktop:hidden': desktop_hide,
        },
        styles.listItemElement,
        customAttributes?.className,
      )}
      style={
        {
          '--marker-color': markerColor || '#000000',
          '--marker-font-weight': markerFontWeight,
          '--marker-font-family': markerFontFamily,
          '--marker-font-size': markerFontSize,
          // This adds the ability to override styles for editor purposes.
          ...((rest.style || {}) as CSSProperties),
        } as CSSProperties
      }
      {...attributes}
    >
      {children}
    </li>
  );
}
